/**
 * Shop, cart, and checkout chrome (not catalog product names).
 * Placeholders use {name} with fmt() from ./format.
 */

const en = {
  pageTitle: 'Shop Celtic Fiddle Music Books & CDs | Cranford Publications',
  pageDescription:
    'Buy authentic Cape Breton, Scottish and Irish fiddle music books and CDs. The Cape Breton Musical Heritage Series, traditional tune collections, recordings. Worldwide shipping since 1999.',
  h1: 'Shop Celtic Fiddle Music Books & CDs',
  keywords:
    'buy celtic music, fiddle music books, Cape Breton music CDs, Irish fiddle books, Scottish fiddle music, traditional music shop, Cranford Publications',
  itemListName: 'Celtic Fiddle Music Products',
  collectionHeading: 'Shop Our Collection',
  loadingProducts: 'Loading products...',
  searchPlaceholder: 'Search products...',
  productCountOne: '{count} product',
  productCountMany: '{count} products',
  clear: 'Clear',
  clearFiltersTitle: 'Clear all filters',
  formatCollection: 'Format & Collection',
  allProducts: 'All Products',
  otherTags: 'Other Tags',
  allTags: 'All Tags',
  tagsIn: 'Tags in {name}',
  allIn: 'All in {name}',
  sortBy: 'Sort by',
  sortName: 'Name (A-Z)',
  sortFeatured: 'Featured First',
  sortPriceLow: 'Price (Low to High)',
  sortPriceHigh: 'Price (High to Low)',
  noProductsTitle: 'No Products Found',
  noProductsText:
    "We couldn't find any products matching your criteria. Try adjusting your search terms or filters.",
  resetFilters: 'Reset All Filters',
  paginationAria: 'Product list pagination',
  paginationItemLabel: 'products',
  pagination: {
    previous: 'Previous page',
    next: 'Next page',
    page: 'Page {n}',
    pageCurrent: 'Page {n}, current page',
    ofTotal: '{range} of {total}',
    perPage: 'Per page:',
    showPerPage: 'Show {n} {label} per page',
  },
  tags: {
    scottish: 'Scottish',
    irish: 'Irish',
    'cape-breton': 'Cape Breton',
    celtic: 'Celtic',
    traditional: 'Traditional',
    fiddle: 'Fiddle',
    pipe: 'Pipes',
    bagpipe: 'Bagpipes',
    reel: 'Reel',
    jig: 'Jig',
    strathspey: 'Strathspey',
    march: 'March',
    hornpipe: 'Hornpipe',
    waltz: 'Waltz',
    polka: 'Polka',
    air: 'Air/Slow',
    books: 'Books',
    book: 'Books',
    'audio-video': 'Audio / Video',
    bundles: 'Bundles',
    'cranford-publications': 'Cranford Publications',
    'cape-breton-heritage': 'Cape Breton Heritage',
    'tune-collections': 'Tune Collections',
    merchandise: 'Merchandise',
    artists: 'Featured Artists',
    beginner: 'Beginner',
    advanced: 'Advanced',
  },
  cart: {
    yourCart: 'Your Cart',
    shoppingCart: 'Shopping Cart',
    closeAria: 'Close cart',
    openAria: 'Open shopping cart',
    empty: 'Your cart is empty.',
    emptyCheckoutTitle: 'Your cart is empty',
    emptyCheckoutText: 'Add some items to your cart before checking out.',
    continueShopping: 'Continue Shopping',
    wholesaleCustomer: 'Wholesale Customer',
    wholesaleGets: 'As a wholesale customer, you get:',
    wholesaleBullet1: 'Volume discounts on bulk orders',
    wholesaleBullet2: 'Tiered pricing based on quantity',
    wholesaleBullet3: 'Special wholesale rates',
    digitalMixed:
      'Digital downloads are not shipped. Shipping applies to physical items only.',
    digitalOnly:
      'Digital downloads are not shipped — delivered online after checkout.',
    subtotal: 'Subtotal:',
    estShipping: 'Est. shipping:',
    processingFee: 'Payment processing fee ({pct}%)',
    estTotal: 'Est. total:',
    feeNoteWithShipping:
      'Processing fee is estimated from subtotal + shipping. Tax and final shipping are confirmed at checkout.',
    feeNoteNoShipping:
      'Processing fee is estimated from subtotal. Tax and final shipping are confirmed at checkout.',
    youreSaving: "You're saving:",
    proceed: 'Proceed to Checkout',
    clearCart: 'Clear Cart',
    clearConfirm: 'Clear all items?',
    yes: 'Yes',
    no: 'No',
    cleared: 'Cart cleared successfully',
    unavailable: 'Item not available',
    freeGift: 'Free gift',
    notShipped: 'Not shipped',
    notShippedTitle: 'Digital and virtual products are not shipped',
    bundle: 'BUNDLE',
    size: 'Size:',
    color: 'Color:',
    saveOff: 'Save {amount} ({pct}% off)',
    qty: 'Qty: {n}',
    decreaseQty: 'Decrease quantity',
    increaseQty: 'Increase quantity',
    removeItem: 'Remove item',
    removeGift: 'Remove free gift',
    removeFromCart: 'Remove from cart',
    removeGiftFromCart: 'Remove free gift from cart',
    itemsCount: '({count} items)',
  },
  product: {
    notAvailable: 'Product not available',
    notFound: 'Product not found.',
    loading: 'Loading product...',
    featured: 'Featured Product',
    wholesaleAvailable: 'Wholesale Pricing Available',
    hiddenFromShop: 'Hidden from public shop',
    price: 'Price:',
    variable: 'Variable',
    upToOff: 'Up to {pct}% off',
    savePct: 'Save {pct}%',
    minWholesale: 'Min qty for wholesale: {n}',
    quantity: 'Quantity:',
    availableDiscounts: 'Available discounts at this quantity:',
    tierOff: '{tier}: {pct}% off',
    outOfStock: 'Out of Stock',
    adding: 'Adding...',
    selectBundle: 'Select Bundle Products',
    selectOptions: 'Select Options',
    addToCart: 'Add to Cart',
    addQtyToCart: 'Add {n} to Cart',
    notifyMe: 'Notify Me When Back in Stock',
    notifySuccess: "You'll be notified when this product is back in stock!",
    notifyEmailPlaceholder: 'Enter your email',
    subscribe: 'Subscribe',
    subscribing: 'Subscribing...',
    cancel: 'Cancel',
    onlyNInStock: 'Only {n} items available in stock',
    addedOne: 'Added 1 item to cart {price}',
    addedMany: 'Added {n} items to cart {price}',
    atWholesale: 'at wholesale price: ${price} each',
    addFailed: 'Could not add item to cart. Try refreshing the page.',
    addFailedRetry: 'Failed to add item to cart. Please try again.',
    notifyFailed: 'Failed to subscribe to notifications',
    notifyFailedRetry: 'Failed to subscribe. Please try again.',
    notifyDefault: 'You will be notified when this product is back in stock!',
    editProduct: 'Edit this product',
    shareProduct: 'Share this product',
    back: 'Back',
    choosePackage: 'Choose your package',
  },
  bundle: {
    packagesFrom: 'Packages from',
    packageSub:
      'One click adds the full package to your cart — book (5% tax) + digital/CD at provincial rate.',
    addToCart: 'Add to cart',
    adding: 'Adding…',
    addedNamed: '"{name}" added to cart — ${price}',
    buildHeading: 'Build your bundle',
    selectedCount: '{n} selected',
    selectedMax: '{n} selected · max {max}',
    selectToBuild: 'Select items below to build your bundle',
    itemsSelectedOne: '{n} item selected',
    itemsSelectedMany: '{n} items selected',
    discountUnlocked: '{pct}% bundle discount unlocked — you\'re saving!',
    pickMinToUnlock: 'Please pick {min} items to unlock {pct}% off',
    pickMoreOne: 'Please pick {n} more item to unlock {pct}% off',
    pickMoreMany: 'Please pick {n} more items to unlock {pct}% off',
    towardDiscount: '{selected} of {min} toward {pct}% discount',
    unknownArtist: 'Unknown',
    oos: 'Out of stock',
    chooseSize: 'Please choose a Size',
    chooseColor: 'Please choose a Color',
    selectedColor: 'Selected color: {color}',
    variantAdjustment: 'Variant adjustment:',
    subtotalCount: 'Subtotal ({n})',
    discountLine: '{pct}% bundle discount',
    total: 'Total',
    pickNItems: 'Please pick {n} item{plural}',
    pickMinOne: 'Please pick {min} item',
    pickMinMany: 'Please pick {min} items',
    toUnlock: ' to unlock {pct}% off',
    upToMax: ' (up to {max} total)',
    addBundle: 'Add bundle to cart',
    addBundleCount: 'Add bundle to cart ({n})',
    loadingProducts: 'Loading bundle products…',
    digitalMp3: 'Digital MP3',
    tuneBook: 'Tune book',
    cd: 'CD',
    errPickOne: 'Please select at least one product for your bundle',
    errMinDiscount: 'Please select at least {n} products to qualify for the bundle discount',
    errVariants: 'Please select size and color for all products with options',
    errAddFailed: 'Failed to add bundle to cart',
    errChoosePackage: 'Please choose one of the bundle packages below',
    errUsePackages: 'Use the bundle packages above to choose your combination',
    errMax: 'You can only select up to {n} products',
    errSize: 'Please select a size',
    errColor: 'Please select a color',
    selectAria: 'Select {name}',
    deselectAria: 'Deselect {name}',
    showItemsOne: 'Show {n} included item',
    showItemsMany: 'Show {n} included items',
    hideItemsOne: 'Hide {n} included item',
    hideItemsMany: 'Hide {n} included items',
    size: 'Size: {value}',
    color: 'Color: {value}',
  },
  checkout: {
    title: 'Checkout',
    stepShopping: 'Shopping',
    stepShipping: 'Shipping',
    stepPayment: 'Payment',
    stepConfirmation: 'Confirmation',
    returnToShop: 'Return to Shopping',
    signIn: 'Sign In',
    signUp: 'Sign Up (new account)',
    continueGuest: 'or continue as guest below',
    loggedInAs: 'Logged in as {name}',
    savedForFuture: 'Your information will be saved for future purchases.',
    verifyTitle: 'Email verification required',
    verifyBody:
      'Please verify your email before completing checkout. Check your inbox for the link, or resend it from your profile. Guest checkout is available if you sign out — or continue after verifying.',
    resendFromProfile: 'resend it from your profile',
    digitalMixed:
      'Digital downloads are delivered online (Profile → Downloads after review). Shipping applies only to the physical items in this order.',
    digitalOnly:
      'Digital download order: Sign in with a verified email before payment. Files appear under Profile → Downloads after we mark the order Completed — nothing is mailed.',
    email: 'Email Address:',
    emailHint: 'Order confirmation will be sent here',
    emailPlaceholder: 'your.email@example.com',
    phone: 'Phone Number:',
    phoneHint: 'For delivery updates',
    firstName: 'First Name:',
    lastName: 'Last Name:',
    shippingAddress: 'Shipping Address',
    updateProfileAddress: 'Update my profile with this shipping address',
    saveProfileAddress: 'Save this shipping address to my profile for future orders',
    updateProfileHint: 'Optional — keeps your Profile shipping details in sync with this order.',
    saveProfileHint: 'Recommended — we noticed your profile has no saved address yet.',
    continuePayment: 'Continue to Payment',
    savingProfile: 'Saving to profile...',
    verifyToContinue: 'Verify email to continue',
    verifyBeforePay: 'Verify your email before continuing to payment',
    mailOrderHint: 'Mail order uses the customer address above and does not update your profile.',
    emailCartUnavailable:
      'Online card and PayPal checkout are temporarily unavailable while we finish testing payments. You can still place an order by choosing Email my cart below — we will send your order to Paul Cranford (and copy admin@cranfordpub.ca).',
    payment: 'Payment',
    paymentIntroEmail: 'Send your cart by email to place an order (no online payment required).',
    paymentIntroChoose: 'Choose a payment method, then complete your purchase below.',
    paymentUnavailable:
      'Online checkout is temporarily unavailable. Please email admin@cranfordpub.ca to place an order.',
    step1Method: 'Step 1 — Choose payment method',
    paymentMethodAria: 'Payment method',
    card: 'Credit / Debit Card',
    sandbox: 'Sandbox',
    live: 'Live',
    stripeTest: 'Stripe test mode',
    stripeSecure: 'Secure checkout via Stripe',
    paypalHintTest: 'PayPal test mode',
    paypalHintLive: 'PayPal balance or linked card',
    selected: 'Selected',
    emailMyCart: 'Email my cart',
    emailCartHint: 'Email order — no online payment',
    step2Pay: 'Step 2 — Complete payment',
    payWithCard: 'Pay with card',
    payWithPaypal: 'Pay with PayPal',
    totalDue: 'Total due:',
    approx: '({amount} approximate)',
    stripeSandboxHint: 'Stripe sandbox: enter test card 4242 4242 4242 4242 (any future expiry and CVC).',
    stripeLiveHint: 'Stripe live mode — real card charges will be processed.',
    processing: 'Processing...',
    payWithCardAmount: 'Pay ${amount} with Card',
    paypalButtonHint:
      'Use the gold PayPal button below to sign in and pay — not the option above.',
    paypalSandboxHint: ' Sign in with the PayPal sandbox test account shown above.',
    paypalButtonLabel: 'PayPal checkout button',
    step2Send: 'Step 2 — Send your cart',
    cartTotal: 'Cart total:',
    emailCartAdminHint:
      'Admin test mode: cart emails go to the address below only — Paul Cranford is not notified.',
    emailCartGuestHint:
      'We will email Paul Cranford your cart (CC admin@cranfordpub.ca) and send you a copy. No payment is taken online — registration is not required.',
    sendTestTo: 'Send test cart to',
    testEmailHint: 'Defaults to your login email. Both cart copies are sent here for testing.',
    personalMessage: 'Personal message',
    optional: '(optional)',
    personalMessagePlaceholder:
      'Add a note for Paul Cranford — timing, questions, or anything about your order.',
    sending: 'Sending…',
    sendMyCart: 'Send my cart',
    sentRef: 'Sent — reference {ref}.',
    sentAdmin: ' Check the test recipient inbox above.',
    sentGuest: ' Check your inbox for a copy.',
    processingPayment: 'Processing payment...',
    backToShipping: 'Back to Shipping',
    orderSummary: 'Order Summary',
    itemFallback: 'Item',
    taxExempt: 'Tax Exempt',
    taxGeneric: 'Tax',
    taxAtCheckout: 'Tax calculated at checkout',
    noTax: 'No tax',
    shippingCalc: 'Shipping Calculation',
    estWeight: 'Est. Weight:',
    rateType: 'Rate Type:',
    flatRate: 'Flat Rate ({dest})',
    shipping: 'Shipping',
    baseShippingHandling: 'Base shipping & handling:',
    postageAdjustment: 'Postage adjustment:',
    rateBandNote: '* rate band changes by item count',
    totalWeight: 'Total Weight:',
    band: 'Band:',
    weightBased: 'Weight Based',
    fixedFlat: 'Fixed Flat Rate Shipping',
    baseRate: 'Base Rate:',
    fuelSurcharge: 'Fuel Surcharge:',
    shippingCost: 'Shipping Cost',
    free: 'FREE',
    errEmptyCart: 'Your cart is empty.',
    errEmailStep: 'Please enter your email address in the contact details step.',
    errTestEmail: 'Please enter the test recipient email address.',
    errValidTestEmail: 'Please enter a valid test recipient email address.',
    errNameStep: 'Please enter your name in the shipping details step.',
    errSendCart: 'Failed to send cart',
    errSendCartRetry: 'Failed to send cart. Please try again.',
    errSession:
      'Your login session was not recognized for payments. Sign out and sign back in, then retry checkout.',
    errKeys:
      'Could not load Stripe/PayPal keys. Hard-refresh the page (Cmd+Shift+R) or sign out and back in.',
    errInitProviders: 'Failed to initialize payment providers: {message}',
    errStripeInit: 'Stripe is not initialized',
    errDigitalAccount: 'Digital downloads require a signed-in account. Please log in or register first.',
    errVerifyEmail:
      'Please verify your email before checkout. Check your inbox or resend the link from your profile.',
    errStripeSession: 'Failed to create Stripe checkout session',
    errPaymentFailed: 'Payment failed',
    errEmailRequired: 'Email is required',
    errEmailInvalid: 'Please enter a valid email',
    errPhoneRequired: 'Phone number is required',
    errPhoneInvalid: 'Please enter a valid phone number',
    errFirstName: 'First name is required',
    errLastName: 'Last name is required',
    errStreet: 'Street address is required',
    errCity: 'City is required',
    errPostal: 'Postal code is required',
    errProvince: 'Province is required for Canadian addresses',
    errState: 'State is required for US addresses',
    errRegion: 'State / province / region is required',
    errCountryName: 'Country name is required for international addresses',
    shippingSavedProfile: 'Shipping saved — address added to your profile',
    shippingSaveProfileFailed:
      'Could not save address to your profile. You can update it later under Profile.',
    shippingSaved: 'Shipping information saved',
    paypalInitFailed: 'Failed to initialize PayPal button. Please refresh the page.',
  },
  address: {
    country: 'Country',
    canada: 'Canada',
    unitedStates: 'United States',
    international: 'International',
    street: 'Street Address',
    streetPlaceholder: '123 Main St',
    line2: 'Address Line 2',
    optional: '(Optional)',
    line2Placeholder: 'Apt, Suite, Buzz Code',
    city: 'City',
    cityPlaceholder: 'Toronto',
    province: 'Province',
    state: 'State',
    region: 'State / Province / Region',
    regionPlaceholder: 'e.g. New South Wales',
    postalCA: 'Postal Code',
    postalUS: 'ZIP Code',
    postalIntl: 'Postal / ZIP Code',
    countryName: 'Country Name',
    otherCountry: 'Enter country name',
    otherCountryAria: 'Country name (other)',
    selectCountry: 'Select country...',
    otherNotListed: 'Other (not listed)',
  },
  success: {
    completing: 'Completing your order...',
    invalidSession: 'Invalid payment session',
    failedComplete: 'Failed to complete order',
    errorTitle: 'Order Error',
    backToCheckout: 'Back to Checkout',
    sandboxBanner:
      'Sandbox test order — This checkout used Stripe test (sandbox) accounts. No real charge was made.',
    liveBanner: 'Live payment — This checkout used Stripe live accounts. A real charge was processed.',
    confirmed: 'Order Confirmed!',
    thankYou: 'Thank you for your purchase',
    orderNumber: 'Order Number',
    emailSent: 'Confirmation Email Sent',
    emailSentText: "We've sent a detailed order confirmation to your email address.",
    next: 'What Happens Next?',
    received: 'Order Received',
    receivedText: 'Your payment has been confirmed',
    review: 'Order review',
    reviewText: 'We review your order before unlocking digital downloads',
    download: 'Download your album',
    downloadText: 'After completion, Profile → Downloads — save your licensed watermarked ZIP',
    redownload: 'Re-download anytime',
    redownloadText: 'Sign in later — repeat downloads use email confirmation',
    processing: 'Processing',
    processingText: "We're preparing your items",
    shipping: 'Shipping',
    shippingText: "You'll receive tracking information via email",
    delivery: 'Delivery',
    deliveryText: 'Your order will arrive within 5-7 business days',
  },
};

const french = (d) => ({
  pageTitle: 'Boutique de livres et CD de fiddle celtique | Cranford Publications',
  pageDescription:
    'Achetez des livres et CD authentiques de fiddle du Cap-Breton, d’Écosse et d’Irlande. La Cape Breton Musical Heritage Series, recueils traditionnels et enregistrements. Livraison mondiale depuis 1999.',
  h1: 'Boutique de livres et CD de fiddle celtique',
  keywords:
    'acheter musique celtique, livres de fiddle, CD Cap-Breton, livres de fiddle irlandais, musique traditionnelle, boutique Cranford Publications',
  itemListName: 'Produits de fiddle celtique',
  collectionHeading: 'Parcourir la collection',
  loadingProducts: 'Chargement des produits...',
  searchPlaceholder: 'Rechercher des produits...',
  productCountOne: '{count} produit',
  productCountMany: '{count} produits',
  clear: 'Effacer',
  clearFiltersTitle: 'Effacer tous les filtres',
  formatCollection: 'Format et collection',
  allProducts: 'Tous les produits',
  otherTags: 'Autres étiquettes',
  allTags: 'Toutes les étiquettes',
  tagsIn: 'Étiquettes dans {name}',
  allIn: 'Tout dans {name}',
  sortBy: 'Trier par',
  sortName: 'Nom (A-Z)',
  sortFeatured: 'En vedette d’abord',
  sortPriceLow: 'Prix (croissant)',
  sortPriceHigh: 'Prix (décroissant)',
  noProductsTitle: 'Aucun produit trouvé',
  noProductsText:
    'Aucun produit ne correspond à vos critères. Essayez d’ajuster la recherche ou les filtres.',
  resetFilters: 'Réinitialiser les filtres',
  paginationAria: 'Pagination de la liste de produits',
  paginationItemLabel: 'produits',
  pagination: {
    previous: 'Page précédente',
    next: 'Page suivante',
    page: 'Page {n}',
    pageCurrent: 'Page {n}, page actuelle',
    ofTotal: '{range} sur {total}',
    perPage: 'Par page :',
    showPerPage: 'Afficher {n} {label} par page',
  },
  tags: {
    scottish: 'Écossais',
    irish: 'Irlandais',
    'cape-breton': 'Cap-Breton',
    celtic: 'Celtique',
    traditional: 'Traditionnel',
    fiddle: 'Fiddle',
    pipe: 'Cornemuses',
    bagpipe: 'Cornemuses',
    reel: 'Reel',
    jig: 'Jig',
    strathspey: 'Strathspey',
    march: 'Marche',
    hornpipe: 'Hornpipe',
    waltz: 'Valse',
    polka: 'Polka',
    air: 'Air / lent',
    books: 'Livres',
    book: 'Livres',
    'audio-video': 'Audio / vidéo',
    bundles: 'Ensembles',
    'cranford-publications': 'Cranford Publications',
    'cape-breton-heritage': 'Patrimoine du Cap-Breton',
    'tune-collections': 'Recueils d’airs',
    merchandise: 'Boutique',
    artists: 'Artistes en vedette',
    beginner: 'Débutant',
    advanced: 'Avancé',
  },
  cart: {
    yourCart: 'Votre panier',
    shoppingCart: 'Panier',
    closeAria: 'Fermer le panier',
    openAria: 'Ouvrir le panier',
    empty: 'Votre panier est vide.',
    emptyCheckoutTitle: 'Votre panier est vide',
    emptyCheckoutText: 'Ajoutez des articles avant de passer à la caisse.',
    continueShopping: 'Continuer vos achats',
    wholesaleCustomer: 'Client de gros',
    wholesaleGets: 'En tant que client de gros, vous bénéficiez de :',
    wholesaleBullet1: 'Rabais de volume sur les commandes en gros',
    wholesaleBullet2: 'Prix par paliers selon la quantité',
    wholesaleBullet3: 'Tarifs de gros spéciaux',
    digitalMixed:
      'Les téléchargements numériques ne sont pas expédiés. Les frais de livraison s’appliquent uniquement aux articles physiques.',
    digitalOnly:
      'Les téléchargements numériques ne sont pas expédiés — livrés en ligne après le paiement.',
    subtotal: 'Sous-total :',
    estShipping: 'Livraison est. :',
    processingFee: 'Frais de traitement ({pct} %)',
    estTotal: 'Total est. :',
    feeNoteWithShipping:
      'Les frais sont estimés à partir du sous-total + livraison. Taxes et livraison finales à la caisse.',
    feeNoteNoShipping:
      'Les frais sont estimés à partir du sous-total. Taxes et livraison finales à la caisse.',
    youreSaving: 'Vous économisez :',
    proceed: 'Passer à la caisse',
    clearCart: 'Vider le panier',
    clearConfirm: 'Vider tous les articles ?',
    yes: 'Oui',
    no: 'Non',
    cleared: 'Panier vidé',
    unavailable: 'Article indisponible',
    freeGift: 'Cadeau',
    notShipped: 'Non expédié',
    notShippedTitle: 'Les produits numériques et virtuels ne sont pas expédiés',
    bundle: 'ENSEMBLE',
    size: 'Taille :',
    color: 'Couleur :',
    saveOff: 'Économisez {amount} ({pct} %)',
    qty: 'Qté : {n}',
    decreaseQty: 'Diminuer la quantité',
    increaseQty: 'Augmenter la quantité',
    removeItem: 'Retirer l’article',
    removeGift: 'Retirer le cadeau',
    removeFromCart: 'Retirer du panier',
    removeGiftFromCart: 'Retirer le cadeau du panier',
    itemsCount: '({count} articles)',
  },
  product: {
    notAvailable: 'Produit indisponible',
    notFound: 'Produit introuvable.',
    loading: 'Chargement du produit...',
    featured: 'Produit en vedette',
    wholesaleAvailable: 'Tarifs de gros disponibles',
    hiddenFromShop: 'Masqué de la boutique publique',
    price: 'Prix :',
    variable: 'Variable',
    upToOff: 'Jusqu’à {pct} % de rabais',
    savePct: 'Économisez {pct} %',
    minWholesale: 'Qté min. pour le gros : {n}',
    quantity: 'Quantité :',
    availableDiscounts: 'Rabais disponibles à cette quantité :',
    tierOff: '{tier} : {pct} %',
    outOfStock: 'Rupture de stock',
    adding: 'Ajout...',
    selectBundle: 'Choisir les produits de l’ensemble',
    selectOptions: 'Choisir les options',
    addToCart: 'Ajouter au panier',
    addQtyToCart: 'Ajouter {n} au panier',
    notifyMe: 'Prévenez-moi du retour en stock',
    notifySuccess: 'Vous serez avisé lorsque ce produit sera de retour.',
    notifyEmailPlaceholder: `Entrez votre ${d.emailNoun}`,
    subscribe: 'S’inscrire',
    subscribing: 'Inscription...',
    cancel: 'Annuler',
    onlyNInStock: 'Seulement {n} articles en stock',
    addedOne: '1 article ajouté au panier {price}',
    addedMany: '{n} articles ajoutés au panier {price}',
    atWholesale: 'au prix de gros : {price} $ chacun',
    addFailed: 'Impossible d’ajouter l’article. Actualisez la page.',
    addFailedRetry: 'Échec de l’ajout. Veuillez réessayer.',
    notifyFailed: 'Échec de l’inscription aux avis',
    notifyFailedRetry: 'Échec de l’inscription. Veuillez réessayer.',
    notifyDefault: 'Vous serez avisé lorsque ce produit sera de retour en stock.',
    editProduct: 'Modifier ce produit',
    shareProduct: 'Partager ce produit',
    back: 'Retour',
    choosePackage: 'Choisissez votre ensemble',
  },
  bundle: {
    packagesFrom: 'Ensembles à partir de',
    packageSub:
      'Un clic ajoute l’ensemble au panier — livre (taxe 5 %) + numérique/CD au taux provincial.',
    addToCart: 'Ajouter au panier',
    adding: 'Ajout…',
    addedNamed: '« {name} » ajouté au panier — {price} $',
    buildHeading: 'Composez votre ensemble',
    selectedCount: '{n} sélectionné(s)',
    selectedMax: '{n} sélectionné(s) · max. {max}',
    selectToBuild: 'Choisissez des articles ci-dessous pour composer votre ensemble',
    itemsSelectedOne: '{n} article sélectionné',
    itemsSelectedMany: '{n} articles sélectionnés',
    discountUnlocked: 'Rabais de {pct} % débloqué — vous économisez !',
    pickMinToUnlock: 'Choisissez {min} articles pour débloquer {pct} % de rabais',
    pickMoreOne: 'Choisissez encore {n} article pour débloquer {pct} % de rabais',
    pickMoreMany: 'Choisissez encore {n} articles pour débloquer {pct} % de rabais',
    towardDiscount: '{selected} sur {min} pour {pct} % de rabais',
    unknownArtist: 'Inconnu',
    oos: 'Rupture de stock',
    chooseSize: 'Veuillez choisir une taille',
    chooseColor: 'Veuillez choisir une couleur',
    selectedColor: 'Couleur choisie : {color}',
    variantAdjustment: 'Ajustement de variante :',
    subtotalCount: 'Sous-total ({n})',
    discountLine: 'Rabais d’ensemble {pct} %',
    total: 'Total',
    pickNItems: 'Choisissez {n} article{plural}',
    pickMinOne: 'Choisissez {min} article',
    pickMinMany: 'Choisissez {min} articles',
    toUnlock: ' pour débloquer {pct} % de rabais',
    upToMax: ' (jusqu’à {max} au total)',
    addBundle: 'Ajouter l’ensemble au panier',
    addBundleCount: 'Ajouter l’ensemble au panier ({n})',
    loadingProducts: 'Chargement des produits de l’ensemble…',
    digitalMp3: 'MP3 numérique',
    tuneBook: 'Livre de mélodies',
    cd: 'CD',
    errPickOne: 'Choisissez au moins un produit pour votre ensemble',
    errMinDiscount: 'Choisissez au moins {n} produits pour le rabais d’ensemble',
    errVariants: 'Choisissez la taille et la couleur pour tous les produits avec options',
    errAddFailed: 'Impossible d’ajouter l’ensemble au panier',
    errChoosePackage: 'Choisissez l’un des ensembles ci-dessous',
    errUsePackages: 'Utilisez les ensembles ci-dessus pour choisir votre combinaison',
    errMax: 'Vous ne pouvez sélectionner que {n} produits',
    errSize: 'Veuillez choisir une taille',
    errColor: 'Veuillez choisir une couleur',
    selectAria: 'Sélectionner {name}',
    deselectAria: 'Désélectionner {name}',
    showItemsOne: 'Afficher {n} article inclus',
    showItemsMany: 'Afficher {n} articles inclus',
    hideItemsOne: 'Masquer {n} article inclus',
    hideItemsMany: 'Masquer {n} articles inclus',
    size: 'Taille : {value}',
    color: 'Couleur : {value}',
  },
  checkout: {
    title: 'Caisse',
    stepShopping: 'Boutique',
    stepShipping: 'Livraison',
    stepPayment: 'Paiement',
    stepConfirmation: 'Confirmation',
    returnToShop: 'Retour à la boutique',
    signIn: 'Connexion',
    signUp: 'Créer un compte',
    continueGuest: 'ou continuez en tant qu’invité ci-dessous',
    loggedInAs: 'Connecté en tant que {name}',
    savedForFuture: 'Vos renseignements seront enregistrés pour vos prochains achats.',
    verifyTitle: `${d.emailLabel} à confirmer`,
    verifyBody: `Veuillez confirmer votre ${d.emailNoun} avant de terminer. Vérifiez votre boîte de réception, ou renvoyez le lien depuis votre profil. Le paiement invité est possible si vous vous déconnectez.`,
    resendFromProfile: 'renvoyez-le depuis votre profil',
    digitalMixed:
      'Les téléchargements numériques sont livrés en ligne (Profil → Téléchargements après révision). La livraison s’applique uniquement aux articles physiques.',
    digitalOnly:
      `Commande numérique : connectez-vous avec un ${d.emailNoun} confirmé avant le paiement. Les fichiers apparaissent sous Profil → Téléchargements une fois la commande terminée — rien n’est posté.`,
    email: `${d.emailLabel} :`,
    emailHint: 'La confirmation de commande sera envoyée ici',
    emailPlaceholder: 'adresse@exemple.com',
    phone: 'Téléphone :',
    phoneHint: 'Pour les mises à jour de livraison',
    firstName: 'Prénom :',
    lastName: 'Nom :',
    shippingAddress: 'Adresse de livraison',
    updateProfileAddress: 'Mettre à jour mon profil avec cette adresse',
    saveProfileAddress: 'Enregistrer cette adresse dans mon profil pour les prochaines commandes',
    updateProfileHint: 'Facultatif — synchronise l’adresse de votre profil avec cette commande.',
    saveProfileHint: 'Recommandé — votre profil n’a pas encore d’adresse enregistrée.',
    continuePayment: 'Continuer vers le paiement',
    savingProfile: 'Enregistrement au profil...',
    verifyToContinue: `Confirmez votre ${d.emailNoun} pour continuer`,
    verifyBeforePay: `Confirmez votre ${d.emailNoun} avant le paiement`,
    mailOrderHint: 'La commande postale utilise l’adresse ci-dessus et ne met pas à jour votre profil.',
    emailCartUnavailable:
      'Le paiement par carte et PayPal est temporairement indisponible. Vous pouvez encore commander en choisissant Envoyer mon panier ci-dessous — nous enverrons la commande à Paul Cranford (copie admin@cranfordpub.ca).',
    payment: 'Paiement',
    paymentIntroEmail: 'Envoyez votre panier par courriel pour commander (aucun paiement en ligne).',
    paymentIntroChoose: 'Choisissez un mode de paiement, puis terminez l’achat ci-dessous.',
    paymentUnavailable:
      'La caisse en ligne est temporairement indisponible. Écrivez à admin@cranfordpub.ca pour commander.',
    step1Method: 'Étape 1 — Choisir le mode de paiement',
    paymentMethodAria: 'Mode de paiement',
    card: 'Carte de crédit / débit',
    sandbox: 'Bac à sable',
    live: 'En direct',
    stripeTest: 'Mode test Stripe',
    stripeSecure: 'Paiement sécurisé via Stripe',
    paypalHintTest: 'Mode test PayPal',
    paypalHintLive: 'Solde PayPal ou carte liée',
    selected: 'Sélectionné',
    emailMyCart: 'Envoyer mon panier',
    emailCartHint: 'Commande par courriel — sans paiement en ligne',
    step2Pay: 'Étape 2 — Effectuer le paiement',
    payWithCard: 'Payer par carte',
    payWithPaypal: 'Payer avec PayPal',
    totalDue: 'Total dû :',
    approx: '({amount} approximatif)',
    stripeSandboxHint: 'Bac à sable Stripe : carte test 4242 4242 4242 4242 (toute date future et CVC).',
    stripeLiveHint: 'Mode Stripe en direct — de vrais frais seront traités.',
    processing: 'Traitement...',
    payWithCardAmount: 'Payer {amount} $ par carte',
    paypalButtonHint:
      'Utilisez le bouton PayPal doré ci-dessous pour vous connecter et payer.',
    paypalSandboxHint: ' Connectez-vous avec le compte test PayPal indiqué ci-dessus.',
    paypalButtonLabel: 'Bouton de paiement PayPal',
    step2Send: 'Étape 2 — Envoyer votre panier',
    cartTotal: 'Total du panier :',
    emailCartAdminHint:
      'Mode test admin : les courriels du panier vont uniquement à l’adresse ci-dessous — Paul Cranford n’est pas avisé.',
    emailCartGuestHint:
      'Nous enverrons votre panier à Paul Cranford (CC admin@cranfordpub.ca) et une copie pour vous. Aucun paiement en ligne — inscription non requise.',
    sendTestTo: 'Envoyer le panier test à',
    testEmailHint: 'Par défaut, votre courriel de connexion. Les deux copies sont envoyées ici pour le test.',
    personalMessage: 'Message personnel',
    optional: '(facultatif)',
    personalMessagePlaceholder:
      'Ajoutez une note pour Paul Cranford — délais, questions ou précisions sur la commande.',
    sending: 'Envoi…',
    sendMyCart: 'Envoyer mon panier',
    sentRef: 'Envoyé — référence {ref}.',
    sentAdmin: ' Vérifiez la boîte du destinataire de test ci-dessus.',
    sentGuest: ' Vérifiez votre boîte de réception pour une copie.',
    processingPayment: 'Traitement du paiement...',
    backToShipping: 'Retour à la livraison',
    orderSummary: 'Récapitulatif',
    itemFallback: 'Article',
    taxExempt: 'Exonéré de taxe',
    taxGeneric: 'Taxe',
    taxAtCheckout: 'Taxe calculée à la caisse',
    noTax: 'Aucune taxe',
    shippingCalc: 'Calcul de la livraison',
    estWeight: 'Poids est. :',
    rateType: 'Type de tarif :',
    flatRate: 'Forfait ({dest})',
    shipping: 'Livraison',
    baseShippingHandling: 'Livraison et manutention de base :',
    postageAdjustment: 'Ajustement de port :',
    rateBandNote: '* le palier change selon le nombre d’articles',
    totalWeight: 'Poids total :',
    band: 'Palier :',
    weightBased: 'Selon le poids',
    fixedFlat: 'Livraison forfaitaire fixe',
    baseRate: 'Tarif de base :',
    fuelSurcharge: 'Surcharge carburant :',
    shippingCost: 'Frais de livraison',
    free: 'GRATUIT',
    errEmptyCart: 'Votre panier est vide.',
    errEmailStep: `Saisissez votre ${d.emailNoun} à l’étape des coordonnées.`,
    errTestEmail: 'Saisissez l’adresse du destinataire de test.',
    errValidTestEmail: 'Saisissez une adresse de test valide.',
    errNameStep: 'Saisissez votre nom à l’étape de livraison.',
    errSendCart: 'Échec de l’envoi du panier',
    errSendCartRetry: 'Échec de l’envoi du panier. Veuillez réessayer.',
    errSession:
      'Votre session n’a pas été reconnue pour le paiement. Déconnectez-vous, reconnectez-vous, puis réessayez.',
    errKeys:
      'Impossible de charger les clés Stripe/PayPal. Actualisez la page (Cmd+Maj+R) ou reconnectez-vous.',
    errInitProviders: 'Échec de l’initialisation des paiements : {message}',
    errStripeInit: 'Stripe n’est pas initialisé',
    errDigitalAccount: 'Les téléchargements numériques exigent un compte. Connectez-vous ou inscrivez-vous.',
    errVerifyEmail: `Veuillez confirmer votre ${d.emailNoun} avant la caisse. Vérifiez votre boîte ou renvoyez le lien depuis votre profil.`,
    errStripeSession: 'Échec de la session Stripe',
    errPaymentFailed: 'Le paiement a échoué',
    errEmailRequired: `${d.emailLabel} requis`,
    errEmailInvalid: `Saisissez un ${d.emailNoun} valide`,
    errPhoneRequired: 'Le téléphone est requis',
    errPhoneInvalid: 'Saisissez un numéro de téléphone valide',
    errFirstName: 'Le prénom est requis',
    errLastName: 'Le nom est requis',
    errStreet: 'L’adresse est requise',
    errCity: 'La ville est requise',
    errPostal: 'Le code postal est requis',
    errProvince: 'La province est requise pour les adresses canadiennes',
    errState: 'L’État est requis pour les adresses américaines',
    errRegion: 'L’État / la province / la région est requis',
    errCountryName: 'Le nom du pays est requis pour les adresses internationales',
    shippingSavedProfile: 'Livraison enregistrée — adresse ajoutée à votre profil',
    shippingSaveProfileFailed:
      'Impossible d’enregistrer l’adresse au profil. Vous pourrez la modifier plus tard.',
    shippingSaved: 'Informations de livraison enregistrées',
    paypalInitFailed: 'Échec du bouton PayPal. Actualisez la page.',
  },
  address: {
    country: 'Pays',
    canada: 'Canada',
    unitedStates: 'États-Unis',
    international: 'International',
    street: 'Adresse',
    streetPlaceholder: '123, rue Principale',
    line2: 'Ligne d’adresse 2',
    optional: '(Facultatif)',
    line2Placeholder: 'App., bureau, code',
    city: 'Ville',
    cityPlaceholder: 'Toronto',
    province: 'Province',
    state: 'État',
    region: 'État / province / région',
    regionPlaceholder: 'p. ex. Nouvelle-Galles du Sud',
    postalCA: 'Code postal',
    postalUS: 'Code ZIP',
    postalIntl: 'Code postal / ZIP',
    countryName: 'Nom du pays',
    otherCountry: 'Saisir le nom du pays',
    otherCountryAria: 'Nom du pays (autre)',
    selectCountry: 'Choisir un pays...',
    otherNotListed: 'Autre (non listé)',
  },
  success: {
    completing: 'Finalisation de votre commande...',
    invalidSession: 'Session de paiement invalide',
    failedComplete: 'Échec de la finalisation de la commande',
    errorTitle: 'Erreur de commande',
    backToCheckout: 'Retour à la caisse',
    sandboxBanner:
      'Commande test — Ce paiement a utilisé des comptes Stripe de test. Aucun frais réel n’a été débité.',
    liveBanner: 'Paiement en direct — Un vrai frais a été traité via Stripe.',
    confirmed: 'Commande confirmée !',
    thankYou: 'Merci pour votre achat',
    orderNumber: 'Numéro de commande',
    emailSent: 'Courriel de confirmation envoyé',
    emailSentText: `Nous avons envoyé une confirmation détaillée à votre ${d.emailNoun}.`,
    next: 'Et ensuite ?',
    received: 'Commande reçue',
    receivedText: 'Votre paiement a été confirmé',
    review: 'Révision de la commande',
    reviewText: 'Nous révisons la commande avant de débloquer les téléchargements',
    download: 'Téléchargez votre album',
    downloadText: 'Après achèvement, Profil → Téléchargements — enregistrez votre ZIP filigrané',
    redownload: 'Retélécharger en tout temps',
    redownloadText: 'Reconnectez-vous plus tard — les retéléchargements utilisent une confirmation par courriel',
    processing: 'Préparation',
    processingText: 'Nous préparons vos articles',
    shipping: 'Expédition',
    shippingText: 'Vous recevrez le suivi par courriel',
    delivery: 'Livraison',
    deliveryText: 'Votre commande arrivera dans 5 à 7 jours ouvrables',
  },
});

const de = {
  pageTitle: 'Shop für keltische Fiddle-Bücher und CDs | Cranford Publications',
  pageDescription:
    'Kaufen Sie authentische Cape-Breton-, schottische und irische Fiddle-Bücher und CDs. Die Cape Breton Musical Heritage Series, traditionelle Sammlungen und Aufnahmen. Weltweiter Versand seit 1999.',
  h1: 'Shop für keltische Fiddle-Bücher und CDs',
  keywords:
    'keltische Musik kaufen, Fiddle-Bücher, Cape-Breton-CDs, irische Fiddle-Bücher, traditioneller Musikshop, Cranford Publications',
  itemListName: 'Keltische Fiddle-Produkte',
  collectionHeading: 'Unsere Kollektion',
  loadingProducts: 'Produkte werden geladen...',
  searchPlaceholder: 'Produkte suchen...',
  productCountOne: '{count} Produkt',
  productCountMany: '{count} Produkte',
  clear: 'Zurücksetzen',
  clearFiltersTitle: 'Alle Filter löschen',
  formatCollection: 'Format & Sammlung',
  allProducts: 'Alle Produkte',
  otherTags: 'Weitere Tags',
  allTags: 'Alle Tags',
  tagsIn: 'Tags in {name}',
  allIn: 'Alles in {name}',
  sortBy: 'Sortieren nach',
  sortName: 'Name (A-Z)',
  sortFeatured: 'Empfohlen zuerst',
  sortPriceLow: 'Preis (aufsteigend)',
  sortPriceHigh: 'Preis (absteigend)',
  noProductsTitle: 'Keine Produkte gefunden',
  noProductsText:
    'Keine Produkte entsprechen Ihren Kriterien. Passen Sie Suche oder Filter an.',
  resetFilters: 'Alle Filter zurücksetzen',
  paginationAria: 'Produktlisten-Seiten',
  paginationItemLabel: 'Produkte',
  pagination: {
    previous: 'Vorherige Seite',
    next: 'Nächste Seite',
    page: 'Seite {n}',
    pageCurrent: 'Seite {n}, aktuelle Seite',
    ofTotal: '{range} von {total}',
    perPage: 'Pro Seite:',
    showPerPage: '{n} {label} pro Seite anzeigen',
  },
  tags: {
    scottish: 'Schottisch',
    irish: 'Irisch',
    'cape-breton': 'Cape Breton',
    celtic: 'Keltisch',
    traditional: 'Traditionell',
    fiddle: 'Fiddle',
    pipe: 'Pfeifen',
    bagpipe: 'Dudelsack',
    reel: 'Reel',
    jig: 'Jig',
    strathspey: 'Strathspey',
    march: 'Marsch',
    hornpipe: 'Hornpipe',
    waltz: 'Walzer',
    polka: 'Polka',
    air: 'Air / langsam',
    books: 'Bücher',
    book: 'Bücher',
    'audio-video': 'Audio / Video',
    bundles: 'Pakete',
    'cranford-publications': 'Cranford Publications',
    'cape-breton-heritage': 'Cape-Breton-Erbe',
    'tune-collections': 'Melodiensammlungen',
    merchandise: 'Merchandise',
    artists: 'Künstler',
    beginner: 'Anfänger',
    advanced: 'Fortgeschritten',
  },
  cart: {
    yourCart: 'Ihr Warenkorb',
    shoppingCart: 'Warenkorb',
    closeAria: 'Warenkorb schließen',
    openAria: 'Warenkorb öffnen',
    empty: 'Ihr Warenkorb ist leer.',
    emptyCheckoutTitle: 'Ihr Warenkorb ist leer',
    emptyCheckoutText: 'Legen Sie Artikel in den Warenkorb, bevor Sie zur Kasse gehen.',
    continueShopping: 'Weiter einkaufen',
    wholesaleCustomer: 'Großhandelskunde',
    wholesaleGets: 'Als Großhandelskunde erhalten Sie:',
    wholesaleBullet1: 'Mengenrabatte bei Großbestellungen',
    wholesaleBullet2: 'Staffelpreise nach Menge',
    wholesaleBullet3: 'Besondere Großhandelspreise',
    digitalMixed:
      'Digitale Downloads werden nicht versendet. Versand gilt nur für physische Artikel.',
    digitalOnly:
      'Digitale Downloads werden nicht versendet — nach dem Kauf online bereitgestellt.',
    subtotal: 'Zwischensumme:',
    estShipping: 'Versand ca.:',
    processingFee: 'Zahlungsgebühr ({pct} %)',
    estTotal: 'Gesamt ca.:',
    feeNoteWithShipping:
      'Gebühr geschätzt aus Zwischensumme + Versand. Steuer und Versand werden an der Kasse bestätigt.',
    feeNoteNoShipping:
      'Gebühr geschätzt aus der Zwischensumme. Steuer und Versand werden an der Kasse bestätigt.',
    youreSaving: 'Sie sparen:',
    proceed: 'Zur Kasse',
    clearCart: 'Warenkorb leeren',
    clearConfirm: 'Alle Artikel entfernen?',
    yes: 'Ja',
    no: 'Nein',
    cleared: 'Warenkorb geleert',
    unavailable: 'Artikel nicht verfügbar',
    freeGift: 'Geschenk',
    notShipped: 'Kein Versand',
    notShippedTitle: 'Digitale und virtuelle Produkte werden nicht versendet',
    bundle: 'PAKET',
    size: 'Größe:',
    color: 'Farbe:',
    saveOff: '{amount} sparen ({pct} %)',
    qty: 'Menge: {n}',
    decreaseQty: 'Menge verringern',
    increaseQty: 'Menge erhöhen',
    removeItem: 'Artikel entfernen',
    removeGift: 'Geschenk entfernen',
    removeFromCart: 'Aus dem Warenkorb entfernen',
    removeGiftFromCart: 'Geschenk aus dem Warenkorb entfernen',
    itemsCount: '({count} Artikel)',
  },
  product: {
    notAvailable: 'Produkt nicht verfügbar',
    notFound: 'Produkt nicht gefunden.',
    loading: 'Produkt wird geladen...',
    featured: 'Empfohlenes Produkt',
    wholesaleAvailable: 'Großhandelspreise verfügbar',
    hiddenFromShop: 'Im öffentlichen Shop ausgeblendet',
    price: 'Preis:',
    variable: 'Variabel',
    upToOff: 'Bis zu {pct} % Rabatt',
    savePct: '{pct} % sparen',
    minWholesale: 'Mindestmenge für Großhandel: {n}',
    quantity: 'Menge:',
    availableDiscounts: 'Rabatte bei dieser Menge:',
    tierOff: '{tier}: {pct} %',
    outOfStock: 'Nicht vorrätig',
    adding: 'Wird hinzugefügt...',
    selectBundle: 'Paketprodukte wählen',
    selectOptions: 'Optionen wählen',
    addToCart: 'In den Warenkorb',
    addQtyToCart: '{n} in den Warenkorb',
    notifyMe: 'Benachrichtigen, wenn wieder da',
    notifySuccess: 'Sie werden benachrichtigt, wenn das Produkt wieder da ist.',
    notifyEmailPlaceholder: 'E-Mail eingeben',
    subscribe: 'Abonnieren',
    subscribing: 'Wird gesendet...',
    cancel: 'Abbrechen',
    onlyNInStock: 'Nur {n} Artikel auf Lager',
    addedOne: '1 Artikel in den Warenkorb {price}',
    addedMany: '{n} Artikel in den Warenkorb {price}',
    atWholesale: 'zum Großhandelspreis: ${price} je Stück',
    addFailed: 'Artikel konnte nicht hinzugefügt werden. Seite neu laden.',
    addFailedRetry: 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.',
    notifyFailed: 'Benachrichtigung fehlgeschlagen',
    notifyFailedRetry: 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
    notifyDefault: 'Sie werden benachrichtigt, wenn das Produkt wieder vorrätig ist.',
    editProduct: 'Dieses Produkt bearbeiten',
    shareProduct: 'Dieses Produkt teilen',
    back: 'Zurück',
    choosePackage: 'Paket wählen',
  },
  bundle: {
    packagesFrom: 'Pakete ab',
    packageSub:
      'Ein Klick legt das ganze Paket in den Warenkorb — Buch (5 % Steuer) + Digital/CD zum Provinzsatz.',
    addToCart: 'In den Warenkorb',
    adding: 'Wird hinzugefügt…',
    addedNamed: '„{name}“ in den Warenkorb — ${price}',
    buildHeading: 'Paket zusammenstellen',
    selectedCount: '{n} ausgewählt',
    selectedMax: '{n} ausgewählt · max. {max}',
    selectToBuild: 'Wählen Sie unten Artikel für Ihr Paket',
    itemsSelectedOne: '{n} Artikel ausgewählt',
    itemsSelectedMany: '{n} Artikel ausgewählt',
    discountUnlocked: '{pct} % Paketrabatt freigeschaltet — Sie sparen!',
    pickMinToUnlock: 'Bitte {min} Artikel wählen, um {pct} % Rabatt freizuschalten',
    pickMoreOne: 'Bitte noch {n} Artikel wählen, um {pct} % Rabatt freizuschalten',
    pickMoreMany: 'Bitte noch {n} Artikel wählen, um {pct} % Rabatt freizuschalten',
    towardDiscount: '{selected} von {min} für {pct} % Rabatt',
    unknownArtist: 'Unbekannt',
    oos: 'Nicht vorrätig',
    chooseSize: 'Bitte eine Größe wählen',
    chooseColor: 'Bitte eine Farbe wählen',
    selectedColor: 'Gewählte Farbe: {color}',
    variantAdjustment: 'Variantenaufschlag:',
    subtotalCount: 'Zwischensumme ({n})',
    discountLine: '{pct} % Paketrabatt',
    total: 'Gesamt',
    pickNItems: 'Bitte {n} Artikel wählen{plural}',
    pickMinOne: 'Bitte {min} Artikel wählen',
    pickMinMany: 'Bitte {min} Artikel wählen',
    toUnlock: ', um {pct} % Rabatt freizuschalten',
    upToMax: ' (insgesamt bis zu {max})',
    addBundle: 'Paket in den Warenkorb',
    addBundleCount: 'Paket in den Warenkorb ({n})',
    loadingProducts: 'Paketprodukte werden geladen…',
    digitalMp3: 'Digital-MP3',
    tuneBook: 'Melodienbuch',
    cd: 'CD',
    errPickOne: 'Bitte mindestens ein Produkt für Ihr Paket wählen',
    errMinDiscount: 'Bitte mindestens {n} Produkte wählen, um den Paketrabatt zu erhalten',
    errVariants: 'Bitte Größe und Farbe für alle Produkte mit Optionen wählen',
    errAddFailed: 'Paket konnte nicht in den Warenkorb gelegt werden',
    errChoosePackage: 'Bitte eines der Pakete unten wählen',
    errUsePackages: 'Nutzen Sie die Pakete oben, um Ihre Kombination zu wählen',
    errMax: 'Sie können höchstens {n} Produkte wählen',
    errSize: 'Bitte eine Größe wählen',
    errColor: 'Bitte eine Farbe wählen',
    selectAria: '{name} auswählen',
    deselectAria: '{name} abwählen',
    showItemsOne: '{n} enthaltenen Artikel anzeigen',
    showItemsMany: '{n} enthaltene Artikel anzeigen',
    hideItemsOne: '{n} enthaltenen Artikel ausblenden',
    hideItemsMany: '{n} enthaltene Artikel ausblenden',
    size: 'Größe: {value}',
    color: 'Farbe: {value}',
  },
  checkout: {
    title: 'Kasse',
    stepShopping: 'Shop',
    stepShipping: 'Versand',
    stepPayment: 'Zahlung',
    stepConfirmation: 'Bestätigung',
    returnToShop: 'Zurück zum Shop',
    signIn: 'Anmelden',
    signUp: 'Konto erstellen',
    continueGuest: 'oder unten als Gast fortfahren',
    loggedInAs: 'Angemeldet als {name}',
    savedForFuture: 'Ihre Daten werden für künftige Käufe gespeichert.',
    verifyTitle: 'E-Mail-Bestätigung erforderlich',
    verifyBody:
      'Bitte bestätigen Sie Ihre E-Mail vor dem Abschluss. Prüfen Sie Ihr Postfach oder senden Sie den Link im Profil erneut. Gastkasse nach Abmeldung möglich.',
    resendFromProfile: 'im Profil erneut senden',
    digitalMixed:
      'Digitale Downloads werden online geliefert (Profil → Downloads nach Prüfung). Versand gilt nur für physische Artikel.',
    digitalOnly:
      'Digitale Bestellung: Melden Sie sich mit bestätigter E-Mail vor der Zahlung an. Dateien erscheinen unter Profil → Downloads, sobald die Bestellung abgeschlossen ist.',
    email: 'E-Mail-Adresse:',
    emailHint: 'Die Bestellbestätigung wird hierher gesendet',
    emailPlaceholder: 'ihre.email@example.com',
    phone: 'Telefon:',
    phoneHint: 'Für Versandupdates',
    firstName: 'Vorname:',
    lastName: 'Nachname:',
    shippingAddress: 'Lieferadresse',
    updateProfileAddress: 'Profil mit dieser Lieferadresse aktualisieren',
    saveProfileAddress: 'Diese Lieferadresse im Profil für künftige Bestellungen speichern',
    updateProfileHint: 'Optional — hält Ihre Profiladresse mit dieser Bestellung synchron.',
    saveProfileHint: 'Empfohlen — in Ihrem Profil ist noch keine Adresse gespeichert.',
    continuePayment: 'Weiter zur Zahlung',
    savingProfile: 'Wird im Profil gespeichert...',
    verifyToContinue: 'E-Mail bestätigen, um fortzufahren',
    verifyBeforePay: 'E-Mail vor der Zahlung bestätigen',
    mailOrderHint: 'Die Postbestellung nutzt die Adresse oben und ändert Ihr Profil nicht.',
    emailCartUnavailable:
      'Karten- und PayPal-Zahlung sind vorübergehend nicht verfügbar. Sie können trotzdem bestellen, indem Sie „Warenkorb senden“ wählen — wir schicken die Bestellung an Paul Cranford (Kopie admin@cranfordpub.ca).',
    payment: 'Zahlung',
    paymentIntroEmail: 'Senden Sie Ihren Warenkorb per E-Mail, um zu bestellen (keine Online-Zahlung).',
    paymentIntroChoose: 'Wählen Sie eine Zahlungsart und schließen Sie den Kauf ab.',
    paymentUnavailable:
      'Die Online-Kasse ist vorübergehend nicht verfügbar. Schreiben Sie an admin@cranfordpub.ca.',
    step1Method: 'Schritt 1 — Zahlungsart wählen',
    paymentMethodAria: 'Zahlungsart',
    card: 'Kredit- / Debitkarte',
    sandbox: 'Sandbox',
    live: 'Live',
    stripeTest: 'Stripe-Testmodus',
    stripeSecure: 'Sichere Zahlung über Stripe',
    paypalHintTest: 'PayPal-Testmodus',
    paypalHintLive: 'PayPal-Guthaben oder hinterlegte Karte',
    selected: 'Ausgewählt',
    emailMyCart: 'Warenkorb senden',
    emailCartHint: 'Bestellung per E-Mail — ohne Online-Zahlung',
    step2Pay: 'Schritt 2 — Zahlung abschließen',
    payWithCard: 'Mit Karte zahlen',
    payWithPaypal: 'Mit PayPal zahlen',
    totalDue: 'Fälliger Betrag:',
    approx: '({amount} ungefähr)',
    stripeSandboxHint: 'Stripe-Sandbox: Testkarte 4242 4242 4242 4242 (beliebiges zukünftiges Datum und CVC).',
    stripeLiveHint: 'Stripe-Live-Modus — echte Kartenzahlungen werden ausgeführt.',
    processing: 'Wird verarbeitet...',
    payWithCardAmount: '{amount} $ mit Karte zahlen',
    paypalButtonHint:
      'Nutzen Sie den goldenen PayPal-Button unten zum Anmelden und Bezahlen.',
    paypalSandboxHint: ' Melden Sie sich mit dem oben gezeigten PayPal-Testkonto an.',
    paypalButtonLabel: 'PayPal-Zahlungsbutton',
    step2Send: 'Schritt 2 — Warenkorb senden',
    cartTotal: 'Warenkorbsumme:',
    emailCartAdminHint:
      'Admin-Test: Warenkorb-E-Mails gehen nur an die Adresse unten — Paul Cranford wird nicht benachrichtigt.',
    emailCartGuestHint:
      'Wir senden Ihren Warenkorb an Paul Cranford (CC admin@cranfordpub.ca) und eine Kopie an Sie. Keine Online-Zahlung — Registrierung nicht nötig.',
    sendTestTo: 'Testwarenkorb senden an',
    testEmailHint: 'Standard ist Ihre Login-E-Mail. Beide Kopien gehen zum Test hierhin.',
    personalMessage: 'Persönliche Nachricht',
    optional: '(optional)',
    personalMessagePlaceholder:
      'Notiz für Paul Cranford — Zeitrahmen, Fragen oder Hinweise zur Bestellung.',
    sending: 'Wird gesendet…',
    sendMyCart: 'Warenkorb senden',
    sentRef: 'Gesendet — Referenz {ref}.',
    sentAdmin: ' Prüfen Sie das Test-Postfach oben.',
    sentGuest: ' Prüfen Sie Ihr Postfach auf eine Kopie.',
    processingPayment: 'Zahlung wird verarbeitet...',
    backToShipping: 'Zurück zum Versand',
    orderSummary: 'Bestellübersicht',
    itemFallback: 'Artikel',
    taxExempt: 'Steuerfrei',
    taxGeneric: 'Steuer',
    taxAtCheckout: 'Steuer wird an der Kasse berechnet',
    noTax: 'Keine Steuer',
    shippingCalc: 'Versandberechnung',
    estWeight: 'Gewicht ca.:',
    rateType: 'Tarifart:',
    flatRate: 'Pauschale ({dest})',
    shipping: 'Versand',
    baseShippingHandling: 'Grundversand & Bearbeitung:',
    postageAdjustment: 'Portoanpassung:',
    rateBandNote: '* Tarifstufe ändert sich mit der Stückzahl',
    totalWeight: 'Gesamtgewicht:',
    band: 'Stufe:',
    weightBased: 'Gewichtsbasiert',
    fixedFlat: 'Fester Pauschalversand',
    baseRate: 'Grundtarif:',
    fuelSurcharge: 'Treibstoffzuschlag:',
    shippingCost: 'Versandkosten',
    free: 'KOSTENLOS',
    errEmptyCart: 'Ihr Warenkorb ist leer.',
    errEmailStep: 'Bitte geben Sie Ihre E-Mail im Kontaktschritt ein.',
    errTestEmail: 'Bitte geben Sie die Test-Empfängeradresse ein.',
    errValidTestEmail: 'Bitte geben Sie eine gültige Test-E-Mail ein.',
    errNameStep: 'Bitte geben Sie Ihren Namen im Versandschritt ein.',
    errSendCart: 'Warenkorb konnte nicht gesendet werden',
    errSendCartRetry: 'Senden fehlgeschlagen. Bitte erneut versuchen.',
    errSession:
      'Ihre Anmeldung wurde für Zahlungen nicht erkannt. Melden Sie sich ab und wieder an.',
    errKeys:
      'Stripe/PayPal-Schlüssel konnten nicht geladen werden. Seite neu laden oder neu anmelden.',
    errInitProviders: 'Zahlungsanbieter fehlgeschlagen: {message}',
    errStripeInit: 'Stripe ist nicht initialisiert',
    errDigitalAccount: 'Digitale Downloads erfordern ein Konto. Bitte anmelden oder registrieren.',
    errVerifyEmail:
      'Bitte bestätigen Sie Ihre E-Mail vor der Kasse. Prüfen Sie Ihr Postfach oder senden Sie den Link im Profil erneut.',
    errStripeSession: 'Stripe-Sitzung fehlgeschlagen',
    errPaymentFailed: 'Zahlung fehlgeschlagen',
    errEmailRequired: 'E-Mail ist erforderlich',
    errEmailInvalid: 'Bitte eine gültige E-Mail eingeben',
    errPhoneRequired: 'Telefonnummer ist erforderlich',
    errPhoneInvalid: 'Bitte eine gültige Telefonnummer eingeben',
    errFirstName: 'Vorname ist erforderlich',
    errLastName: 'Nachname ist erforderlich',
    errStreet: 'Straße ist erforderlich',
    errCity: 'Ort ist erforderlich',
    errPostal: 'Postleitzahl ist erforderlich',
    errProvince: 'Provinz ist für kanadische Adressen erforderlich',
    errState: 'Bundesstaat ist für US-Adressen erforderlich',
    errRegion: 'Staat / Provinz / Region ist erforderlich',
    errCountryName: 'Ländername ist für internationale Adressen erforderlich',
    shippingSavedProfile: 'Versand gespeichert — Adresse im Profil hinterlegt',
    shippingSaveProfileFailed:
      'Adresse konnte nicht im Profil gespeichert werden. Sie können sie später unter Profil ändern.',
    shippingSaved: 'Versandinformationen gespeichert',
    paypalInitFailed: 'PayPal-Button fehlgeschlagen. Bitte Seite neu laden.',
  },
  address: {
    country: 'Land',
    canada: 'Kanada',
    unitedStates: 'Vereinigte Staaten',
    international: 'International',
    street: 'Straße und Hausnummer',
    streetPlaceholder: 'Hauptstraße 123',
    line2: 'Adresszeile 2',
    optional: '(Optional)',
    line2Placeholder: 'Wohnung, Suite, Code',
    city: 'Ort',
    cityPlaceholder: 'Toronto',
    province: 'Provinz',
    state: 'Bundesstaat',
    region: 'Staat / Provinz / Region',
    regionPlaceholder: 'z. B. New South Wales',
    postalCA: 'Postleitzahl',
    postalUS: 'ZIP-Code',
    postalIntl: 'PLZ / ZIP',
    countryName: 'Ländername',
    otherCountry: 'Ländername eingeben',
    otherCountryAria: 'Ländername (andere)',
    selectCountry: 'Land wählen...',
    otherNotListed: 'Andere (nicht gelistet)',
  },
  success: {
    completing: 'Bestellung wird abgeschlossen...',
    invalidSession: 'Ungültige Zahlungssitzung',
    failedComplete: 'Bestellung konnte nicht abgeschlossen werden',
    errorTitle: 'Bestellfehler',
    backToCheckout: 'Zurück zur Kasse',
    sandboxBanner:
      'Sandbox-Testbestellung — Dieser Checkout nutzte Stripe-Testkonten. Es wurde nichts wirklich belastet.',
    liveBanner: 'Live-Zahlung — Dieser Checkout nutzte Stripe-Live-Konten. Eine echte Zahlung wurde ausgeführt.',
    confirmed: 'Bestellung bestätigt!',
    thankYou: 'Vielen Dank für Ihren Einkauf',
    orderNumber: 'Bestellnummer',
    emailSent: 'Bestätigungs-E-Mail gesendet',
    emailSentText: 'Wir haben eine detaillierte Bestätigung an Ihre E-Mail gesendet.',
    next: 'Wie geht es weiter?',
    received: 'Bestellung eingegangen',
    receivedText: 'Ihre Zahlung wurde bestätigt',
    review: 'Prüfung',
    reviewText: 'Wir prüfen die Bestellung, bevor Downloads freigeschaltet werden',
    download: 'Album herunterladen',
    downloadText: 'Nach Abschluss: Profil → Downloads — speichern Sie Ihre lizenzierte ZIP-Datei',
    redownload: 'Jederzeit erneut herunterladen',
    redownloadText: 'Später anmelden — erneute Downloads per E-Mail-Bestätigung',
    processing: 'Vorbereitung',
    processingText: 'Wir bereiten Ihre Artikel vor',
    shipping: 'Versand',
    shippingText: 'Sie erhalten Tracking-Informationen per E-Mail',
    delivery: 'Lieferung',
    deliveryText: 'Ihre Bestellung kommt in 5–7 Werktagen an',
  },
};

const ga = {
  ...en,
  pageTitle: 'Siopa leabhar agus CD fidil Cheilteach | Cranford Publications',
  h1: 'Siopa leabhar agus CD fidil Cheilteach',
  collectionHeading: 'Siopa ár mbailiúchán',
  loadingProducts: 'Táirgí á lódáil...',
  searchPlaceholder: 'Cuardaigh táirgí...',
  productCountOne: '{count} táirge',
  productCountMany: '{count} táirge',
  clear: 'Glan',
  formatCollection: 'Formáid agus bailiúchán',
  allProducts: 'Gach táirge',
  sortBy: 'Sórtáil de réir',
  sortName: 'Ainm (A-Z)',
  sortFeatured: 'Gnéithe ar dtús',
  sortPriceLow: 'Praghas (íseal go hard)',
  sortPriceHigh: 'Praghas (ard go híseal)',
  noProductsTitle: 'Níor aimsíodh táirgí',
  resetFilters: 'Athshocraigh na scagairí',
  cart: {
    ...en.cart,
    yourCart: 'Do chiseán',
    shoppingCart: 'Ciseán siopadóireachta',
    empty: 'Tá do chiseán folamh.',
    continueShopping: 'Lean ar aghaidh ag siopadóireacht',
    proceed: 'Téigh chuig an tseiceáil',
    clearCart: 'Glan an ciseán',
    yes: 'Tá',
    no: 'Níl',
  },
  product: {
    ...en.product,
    addToCart: 'Cuir sa chiseán',
    outOfStock: 'As stoc',
    cancel: 'Cealaigh',
  },
  checkout: {
    ...en.checkout,
    title: 'Seiceáil amach',
    stepShopping: 'Siopa',
    stepShipping: 'Seoladh',
    stepPayment: 'Íocaíocht',
    stepConfirmation: 'Deimhniú',
    signIn: 'Logáil isteach',
    signUp: 'Cruthaigh cuntas',
    payment: 'Íocaíocht',
    continuePayment: 'Ar aghaidh chuig an íocaíocht',
    backToShipping: 'Ar ais chuig an seoladh',
    orderSummary: 'Achoimre ordaithe',
  },
  address: {
    ...en.address,
    country: 'Tír',
    street: 'Seoladh sráide',
    city: 'Cathair',
    province: 'Cúige',
    postalCA: 'Cód poist',
  },
  success: {
    ...en.success,
    confirmed: 'Ordú deimhnithe!',
    thankYou: 'Go raibh maith agat as do cheannach',
    continueShopping: 'Lean ar aghaidh ag siopadóireacht',
  },
};

const gd = {
  ...en,
  pageTitle: 'Bùth leabhraichean is CDan fìdhle Cheilteach | Cranford Publications',
  h1: 'Bùth leabhraichean is CDan fìdhle Cheilteach',
  collectionHeading: 'Bùth ar cruinneachadh',
  loadingProducts: 'A’ luchdadh thoraidhean...',
  searchPlaceholder: 'Lorg toraidhean...',
  productCountOne: '{count} toradh',
  productCountMany: '{count} toraidhean',
  clear: 'Falamhaich',
  formatCollection: 'Cruth is cruinneachadh',
  allProducts: 'A h-uile toradh',
  sortBy: 'Seòrsaich a rèir',
  sortName: 'Ainm (A-Z)',
  sortFeatured: 'Sònraichte an toiseach',
  sortPriceLow: 'Prìs (ìosal gu àrd)',
  sortPriceHigh: 'Prìs (àrd gu ìosal)',
  noProductsTitle: 'Cha deach toraidhean a lorg',
  resetFilters: 'Ath-shuidhich na criathragan',
  cart: {
    ...en.cart,
    yourCart: 'Do chairt',
    shoppingCart: 'Cairt bhùithte',
    empty: 'Tha do chairt falamh.',
    continueShopping: 'Lean ort a’ ceannach',
    proceed: 'Air adhart chun a’ phàighidh',
    clearCart: 'Falamhaich a’ chairt',
    yes: 'Tha',
    no: 'Chan eil',
  },
  product: {
    ...en.product,
    addToCart: 'Cuir sa chairt',
    outOfStock: 'Gun stoc',
    cancel: 'Sguir dheth',
  },
  checkout: {
    ...en.checkout,
    title: 'Pàigheadh',
    stepShopping: 'Bùth',
    stepShipping: 'Lìbhrigeadh',
    stepPayment: 'Pàigheadh',
    stepConfirmation: 'Dearbhadh',
    signIn: 'Log a-steach',
    signUp: 'Cruthaich cunntas',
    payment: 'Pàigheadh',
    continuePayment: 'Air adhart chun a’ phàighidh',
    backToShipping: 'Air ais chun an lìbhrigidh',
    orderSummary: 'Geàrr-chunntas òrduigh',
  },
  address: {
    ...en.address,
    country: 'Dùthaich',
    street: 'Seòladh sràide',
    city: 'Baile',
    province: 'Roinn-dùthcha',
    postalCA: 'Còd-puist',
  },
  success: {
    ...en.success,
    confirmed: 'Òrdugh dearbhte!',
    thankYou: 'Tapadh leibh airson do cheannach',
  },
};

const frCA = french({
  emailNoun: 'courriel',
  emailAdj: 'courriel',
  emailLabel: 'Courriel',
});

const frFR = french({
  emailNoun: 'e-mail',
  emailAdj: 'e-mail',
  emailLabel: 'E-mail',
});

const enGB = {
  ...en,
  pageDescription: en.pageDescription.replace('shipping', 'delivery'),
  checkout: {
    ...en.checkout,
    stepShipping: 'Delivery',
    shippingAddress: 'Delivery address',
    backToShipping: 'Back to Delivery',
    shipping: 'Delivery',
    shippingCost: 'Delivery cost',
    shippingCalc: 'Delivery calculation',
    baseShippingHandling: 'Base delivery & handling:',
  },
  success: {
    ...en.success,
    shipping: 'Delivery',
    shippingText: "You'll receive tracking information via email",
  },
};

export const SHOP_MESSAGES = {
  en,
  'en-US': en,
  'en-GB': enGB,
  'fr-CA': frCA,
  'fr-FR': frFR,
  de,
  ga,
  gd,
};
